import React from 'react'

const Cp_ops = () => {
    return (
        <div className='container'>
            <td>



<h1 class="h1">C++ OOPs Concepts</h1>
<p>The major purpose of C++ programming is to introduce the concept of object orientation to the C programming language.</p>
<p>Object Oriented Programming is a paradigm that provides many concepts such as <strong>inheritance, data binding, polymorphism etc.</strong></p>
<p>The programming paradigm where everything is represented as an object is known as truly object-oriented programming language. <strong>Smalltalk</strong> is considered as the first truly object-oriented programming language.</p>
<hr/>
<h2 class="h2">OOPs (Object Oriented Programming System)</h2>
<p><strong>Object</strong> means a real word entity such as pen, chair, table etc. <strong>Object-Oriented Programming</strong> is a methodology or paradigm to design a program using classes and objects. It simplifies the software development and maintenance by providing some concepts:</p>
<ul class="points">
<li>Object</li>
<li>Class</li>
<li>Inheritance</li>
<li>Polymorphism</li>
<li>Abstraction</li>
<li>Encapsulation</li>
</ul>

<h3 class="h3">Object</h3>
<p>Any entity that has state and behavior is known as an object. For example: chair, pen, table, keyboard, bike etc. It can be physical and logical.</p>
<h3 class="h3">Class</h3>
<p><strong>Collection of objects</strong> is called class. It is a logical entity.</p>
<h3 class="h3">Inheritance</h3>
<p><strong>When one object acquires all the properties and behaviours of parent object</strong> i.e. known as inheritance. It provides code reusability. It is used to achieve runtime polymorphism.</p>
<h3 class="h3">Polymorphism</h3>
<p>When <strong>one task is performed by different ways</strong> i.e. known as polymorphism. For example: to convince the customer differently, to draw something e.g. shape or rectangle etc.</p>
<p>In C++, we use Function overloading and Function overriding to achieve polymorphism.</p>
<h3 class="h3">Abstraction</h3>
<p><strong>Hiding internal details and showing functionality</strong> is known as abstraction. For example: phone call, we don't know the internal processing.</p>
<p>In C++, we use abstract class and interface to achieve abstraction.</p>
<h3 class="h3">Encapsulation</h3>
<p><strong>Binding (or wrapping) code and data together into a single unit is known as encapsulation.</strong> For example: capsule, it is wrapped with different medicines.</p>
<hr/>
<h2 class="h2">Advantage of OOPs over Procedure-oriented programming language</h2>
<ol class="points">
<li>OOPs makes development and maintenance easier where as in Procedure-oriented programming language it is not easy to manage if code grows as project size grows.</li>
<li>OOPs provide data hiding whereas in Procedure-oriented programming language a global data can be accessed from anywhere.</li>
<li>OOPs provide ability to simulate real-world event much more effectively. We can provide the solution of real word problem if we are using the Object-Oriented Programming language.</li>
</ol>

<hr/>


<br/><br/>



<br/><br/>
</td>
        </div>
    )
}

export default Cp_ops
